"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFound = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var storybook_2 = require("@eyecons/storybook");
function NotFound(_a) {
    var className = _a.className;
    return react_1.default.createElement("div", { className: storybook_2.Helpers.classNames('storybook-pages-not-found', className) },
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h1' }, "404"),
        react_1.default.createElement("p", null, "Page not found"),
        react_1.default.createElement("p", null, "The request url does not exist on this server"));
}
exports.NotFound = NotFound;
